import { render } from "./DocumentReportOrigin.vue?vue&type=template&id=5a5d4058&scoped=true&ts=true"
import script from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"
export * from "./DocumentReportOrigin.vue?vue&type=script&lang=ts"

import "./DocumentReportOrigin.vue?vue&type=style&index=0&id=5a5d4058&scoped=true&lang=css"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5d4058"]])

export default __exports__